import { useMutation, useQuery } from "@tanstack/react-query";
import { del, get, post, put } from "./request";

const NOTIFICATION_BASE_URL = '/api/v1';

export function useGetAllNotificationTemplateTypes() {
    const { data, isFetching, refetch } = useQuery(
        ['notifyTemplateTypes'],
        async () => await get(`${NOTIFICATION_BASE_URL}/notify_template_types`),
        {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            staleTime: Infinity
        }
    );
    let items = (data || { data: {} }).data.items;
    let meta = (data || { data: { meta: {} } }).data.meta;
    return { 
      template_types: items, 
      total: meta.total_count,
      isFetching, refetch 
    };
}

export function useGetAllTemplates(payload: any, enabled = true) {
    const { data, isFetching, refetch } = useQuery(
        ['notificationTemplates', payload],
        async () => await get(`${NOTIFICATION_BASE_URL}/notify_templates`, payload),
        {
            refetchOnMount: true,
            refetchOnWindowFocus: false,
            enabled
        }
    );
    let items = (data || { data: {} }).data.items;
    let meta = (data || { data: { meta: {} } }).data.meta;

    return { 
      templates: items, 
      total: meta.total_count, 
      isFetching, refetch 
    };
}


export function useCreateNotificationTemplate(onSuccess?: any, onError?: any) {
    const { mutate: createNotificationTemplate, error, isLoading: creating } = useMutation(
        ['createNotificationTemplate'],
        async (payload: any) => await post(`${NOTIFICATION_BASE_URL}/notify_templates`, payload),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { createNotificationTemplate, error, creating };
}

export function useUpdateNotificationTemplate(onSuccess?: any, onError?: any) {
    const { mutate: updateNotificationTemplate, error, isLoading: updating } = useMutation(
        ['updateNotificationTemplate'],
        async (payload: any) => await put(`${NOTIFICATION_BASE_URL}/notify_templates/${payload.id}`, payload),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { updateNotificationTemplate, error, updating };
}

export function useDeleteNotificationTemplate(onSuccess?: any, onError?: any) {
    const { mutate: deleteNotificationTemplate, error, isLoading: deleting } = useMutation(
        ['deleteNotificationTemplate'],
        async (id) => await del(`${NOTIFICATION_BASE_URL}//notify_templates/${id}`),
        {
            onError,
            onSuccess: (response) => {
                const data = (response || {}).data || {};
                onSuccess(data);
            }
        }
    );
    return { deleteNotificationTemplate, error, deleting };
}
